import { computed } from 'vue'
// types
import type { BtnPrimaryHookOptions, BtnPrimaryHookReturn } from '../types/interfaces'

export const useBtnPrimary = ({ props, onClick }: BtnPrimaryHookOptions): BtnPrimaryHookReturn => {
  const classList = computed<string[]>(() => [
    'ui-btn-primary',
    `ui-btn-primary--${props.color}`,
    `ui-btn-primary--${props.size}`,
    `ui-btn-primary--${props.elementWidth}`,
  ])

  const handleClick = (): void => {
    onClick()
  }

  return {
    classList,
    handleClick,
  }
}